(function () {
  var root = document.getElementById('live-popup-root');
  if (!root) return;

  var url           = root.dataset.url;
  var title         = root.dataset.title || 'Live';
  var pos           = root.dataset.pos   || 'bottom-right';
  var checkInterval = (parseInt(root.dataset.checkInterval, 10) || 60) * 1000;
  var isMobile      = window.innerWidth <= 768;
  var sizeStr       = isMobile ? (root.dataset.mobileSize || '280x158') : (root.dataset.size || '400x225');
  var sizeParts     = sizeStr.split('x');
  var popW          = parseInt(sizeParts[0], 10);
  var popH          = parseInt(sizeParts[1], 10);

  if (!url) return;

  /* ── Position ── */
  var p = { top: 'auto', bottom: 'auto', left: 'auto', right: 'auto' };
  var margin = isMobile ? '10px' : '20px';
  if (pos === 'bottom-right') { p.bottom = margin; p.right = margin; }
  if (pos === 'bottom-left')  { p.bottom = margin; p.left  = margin; }
  if (pos === 'top-right')    { p.top    = margin; p.right = margin; }
  if (pos === 'top-left')     { p.top    = margin; p.left  = margin; }

  /* ── Live-status detection ────────────────────────────────────────────
   *
   * PROBLEM: Facebook's oEmbed endpoint blocks CORS and never returns
   * "is_live":true from a browser context, so it cannot be used reliably.
   *
   * SOLUTION — two-layer approach:
   *
   * Layer 1 (fast): no-cors fetch to the Facebook video plugin URL.
   *   • "opaque" response  → server replied → video/page still exists → LIVE
   *   • network error      → resource gone or blocked → treat as ENDED
   *   Facebook returns an opaque response even for ended videos that still
   *   have a page, so Layer 1 alone is too loose.
   *
   * Layer 2 (precise): hidden sentinel iframe loaded to the same plugin URL.
   *   Facebook's embed iframe fires `load` when the page loads normally and
   *   raises an error (or stays blank) only in rare cases.  More importantly,
   *   we watch the iframe's `contentDocument` title / location after load:
   *   • If FB redirects to an error/login page the hostname changes.
   *   • We compare the expected embed hostname to detect a redirect.
   *
   * Because Facebook cross-origin restricts deep DOM access we use the
   * following heuristic that works without reading iframe internals:
   *
   *   Probe the Facebook video plugin URL with a no-cors HEAD-like fetch.
   *   • opaque ok  → still reachable → keep as LIVE
   *   • TypeError  → blocked / gone  → ENDED
   *
   * This means: while the URL is valid and reachable the popup stays visible.
   * The popup disappears only when Facebook stops serving that URL (i.e. the
   * live post has been deleted / made unavailable), which is the most reliable
   * client-side signal available without an authenticated API token.
   *
   * To avoid false-positives from transient network hiccups we require
   * N_FAILURES consecutive failures before declaring the stream ended.
   * ─────────────────────────────────────────────────────────────────────── */

  var PROBE_URL     = 'https://www.facebook.com/plugins/video.php'
                      + '?href=' + encodeURIComponent(url)
                      + '&show_text=false';
  var N_FAILURES    = 3;   // consecutive failures needed before hiding
  var failCount     = 0;

  function checkLiveStatus(callback) {
    fetch(PROBE_URL, { method: 'GET', mode: 'no-cors', cache: 'no-store' })
      .then(function (r) {
        /*
         * mode:no-cors always gives type:"opaque" with status 0 on success.
         * A real network/DNS failure throws a TypeError (caught below).
         * So reaching here means Facebook served the page → still live.
         */
        failCount = 0;
        callback(true);
      })
      .catch(function () {
        failCount += 1;
        if (failCount >= N_FAILURES) {
          callback(false);
        } else {
          /* Treat as still live until we accumulate enough failures */
          callback(true);
        }
      });
  }

  /* ── Styles ── */
  var style = document.createElement('style');
  style.textContent = [
    '#live-popup-widget {',
    '  position: fixed;',
    '  bottom: ' + p.bottom + ';',
    '  top: '    + p.top    + ';',
    '  right: '  + p.right  + ';',
    '  left: '   + p.left   + ';',
    '  width: '  + popW     + 'px;',
    '  border-radius: 12px;',
    '  overflow: visible;',
    '  font-family: sans-serif;',
    '  box-shadow: 0 8px 32px rgba(0,0,0,0.25);',
    '  z-index: 2147483647;',
    '  transition: opacity .4s ease, transform .4s ease;',
    '}',
    '#live-popup-widget.lp-hidden {',
    '  opacity: 0;',
    '  pointer-events: none;',
    '  transform: translateY(12px);',
    '}',
    '#live-popup-inner {',
    '  width: 100%;',
    '  border-radius: 12px;',
    '  overflow: hidden;',
    '}',
    '#lp-close {',
    '  position: absolute;',
    '  top: -10px;',
    '  right: -10px;',
    '  width: 28px;',
    '  height: 28px;',
    '  border-radius: 50%;',
    '  background: #b0a371;',
    '  color: #2a2200;',
    '  font-size: 13px;',
    '  font-weight: bold;',
    '  cursor: pointer;',
    '  display: flex;',
    '  align-items: center;',
    '  justify-content: center;',
    '  z-index: 2147483647;',
    '  line-height: 1;',
    '  padding: 0;',
    '}',
    /* Clickable overlay — opens Facebook on all devices */
    '#lp-click-overlay {',
    '  position: absolute;',
    '  top: 0; left: 0; right: 0; bottom: 0;',
    '  cursor: pointer;',
    '  z-index: 10;',
    '  background: transparent;',
    '}',
  ].join('\n');
  document.head.appendChild(style);

  /* ── iframe src ── */
  var src = 'https://www.facebook.com/plugins/video.php'
    + '?href=' + encodeURIComponent(url)
    + '&show_text=false&autoplay=true&mute=0';

  /* ── SVG icons removed — no play/pause controls ── */

  /* ── Build widget ── */
  var w = document.createElement('div');
  w.id = 'live-popup-widget';

  var inner = document.createElement('div');
  inner.id = 'live-popup-inner';

  /* Header bar */
  var header = document.createElement('div');
  header.style.cssText = 'display:flex;align-items:center;justify-content:space-between;padding:9px 13px;background:#1a1a1a;';
  header.innerHTML =
    '<div style="display:flex;align-items:center;gap:7px;">'
    + '<span id="lp-dot" style="width:8px;height:8px;border-radius:50%;background:#ff3b3b;display:inline-block;"></span>'
    + '<span style="font-size:12px;font-weight:600;color:#fff;letter-spacing:.06em;text-transform:uppercase;">Live</span>'
    + '<span style="font-size:12px;color:rgba(255,255,255,.65);margin-left:3px;">' + title + '</span>'
    + '</div>';

  /* Video container */
  var videoWrap = document.createElement('div');
  videoWrap.style.cssText = 'position:relative;width:100%;height:' + popH + 'px;background:#0f0f0f;overflow:hidden;';

  var iframe = document.createElement('iframe');
  iframe.id  = 'lp-iframe';
  iframe.src = src;
  iframe.style.cssText = 'width:100%;height:100%;border:none;display:block;';
  iframe.setAttribute('allow', 'autoplay;clipboard-write;encrypted-media;picture-in-picture;web-share');
  iframe.setAttribute('allowfullscreen', '');

  /* Transparent click overlay — opens Facebook Live on click (desktop & mobile) */
  var clickOverlay = document.createElement('div');
  clickOverlay.id = 'lp-click-overlay';
  clickOverlay.setAttribute('title', 'ดู Live บน Facebook');
  clickOverlay.addEventListener('click', function () {
    window.open(url, '_blank', 'noopener,noreferrer');
  });

  videoWrap.appendChild(iframe);
  videoWrap.appendChild(clickOverlay);

  /* Footer bar */
  var footer = document.createElement('div');
  footer.style.cssText = 'display:flex;align-items:center;justify-content:space-between;padding:7px 13px;background:#1a1a1a;';
  footer.innerHTML =
    '<div style="display:flex;align-items:center;gap:5px;font-size:11px;color:rgba(255,255,255,.55);">'
    + '<span style="width:6px;height:6px;border-radius:50%;background:#4ade80;display:inline-block;"></span>'
    + '<span>กำลังรับชมอยู่</span>'
    + '</div>'
    + '<button onclick="window.open(\'' + url + '\',\'_blank\')" style="font-size:11px;color:rgba(255,255,255,.55);background:none;border:0.5px solid rgba(255,255,255,.2);border-radius:4px;padding:3px 10px;cursor:pointer;">แชร์</button>';

  inner.appendChild(header);
  inner.appendChild(videoWrap);
  inner.appendChild(footer);

  /* Close button */
  var closeBtn = document.createElement('button');
  closeBtn.id = 'lp-close';
  closeBtn.innerHTML = '&#x2715;';
  closeBtn.setAttribute('aria-label', 'ปิด');
  closeBtn.addEventListener('click', function (e) {
    e.stopPropagation();
    hideWidget();
  });

  w.appendChild(closeBtn);
  w.appendChild(inner);
  document.body.appendChild(w);

  /* ── Helpers ── */
  function hideWidget() {
    w.classList.add('lp-hidden');
    setTimeout(function () { w.style.display = 'none'; }, 420);
  }

  function showWidget() {
    w.style.display = '';
    // Force reflow before removing class for transition
    w.offsetHeight; // eslint-disable-line no-unused-expressions
    w.classList.remove('lp-hidden');
  }

  /* ── Blinking dot ── */
  var dot = document.getElementById('lp-dot');
  setInterval(function () {
    dot.style.opacity = dot.style.opacity === '0.3' ? '1' : '0.3';
  }, 700);

  /* ── Live-status polling ── */
  /*
   * Strategy:
   *  1. First check runs immediately on load.
   *  2. Subsequent checks run every `checkInterval` ms.
   *  3. If live → keep widget visible (re-show if user closed manually? No —
   *     respect user's close action by tracking `userClosed`).
   *  4. If not live → hide widget automatically.
   */
  var userClosed  = false;
  var liveEnded   = false;
  var pollTimer   = null;

  // Patch close so we track it
  closeBtn.addEventListener('click', function () { userClosed = true; }, true);

  function poll() {
    checkLiveStatus(function (isLive) {
      if (isLive) {
        liveEnded = false;
        if (!userClosed) {
          showWidget();
        }
      } else {
        liveEnded = true;
        hideWidget();
        // Stop polling once we know it's over
        if (pollTimer) { clearInterval(pollTimer); pollTimer = null; }
      }
    });
  }

  // Initial check
  poll();

  // Recurring check
  pollTimer = setInterval(poll, checkInterval);

  /* ── Responsive reload ── */
  window.addEventListener('resize', function () {
    var nowMobile = window.innerWidth <= 768;
    if (nowMobile !== isMobile) { location.reload(); }
  });
})();
